import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const SnackbarContext = createContext(null);

export function AppSnackbarProvider({ children }) {
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "info", // success | error | warning | info
    autoHideDuration: 3500,
  });

  const showSnackbar = useCallback((message, severity = "info", autoHideDuration = 3500) => {
    const safeMsg = typeof message === "string"
      ? message
      : message?.message || message?.detail || JSON.stringify(message);
    setSnack({ open: true, message: safeMsg, severity, autoHideDuration });
  }, []);

  const handleClose = useCallback(() => {
    setSnack((s) => ({ ...s, open: false }));
  }, []);

  const value = useMemo(() => ({ showSnackbar }), [showSnackbar]);

  return (
    <SnackbarContext.Provider value={value}>
      {children}
      <Snackbar
        open={snack.open}
        autoHideDuration={snack.autoHideDuration}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity={snack.severity} variant="filled" sx={{ width: "100%" }}>
          {snack.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

export function useAppSnackbar() {
  const ctx = useContext(SnackbarContext);
  if (!ctx) throw new Error("useAppSnackbar must be used within AppSnackbarProvider");
  return ctx;
}
